import Breadcrumbs from '../ui/Breadcrumbs';

const PortfolioHero = ({breadcrumbsList, text, title, subtitle}) => {



  return (
    <section  className="container-max container-padding w-full relative">
      <div className='flex  flex-col  w-full'>
        <div className='w-full py-[2rem] lg:pt-[2.4rem] xl:pt-[4rem]'>
          <Breadcrumbs
            items={breadcrumbsList}
            separator="/"
            itemClassName="text-base tracking-wide"
            linkClassName="text-[#bda76a]"
            currentClassName="text-[#0f1626]"
            separatorClassName="text-[#bda76a]"
          />
        </div>

        <div className='w-full flex-col pt-[1.6rem] pb-[2.4rem] md:pt-[2rem] lg:pb-[6rem] xl:pt-[4rem] xl:pb-[8rem]'>
            <h1 className="heading-2 text-[3.6rem] md:text-[5.2rem] lg:text-[6rem] xl:text-[8rem] lg:max-w-[55%] md:max-w-[72rem] mb-[1.6rem] lg:mb-[2.4rem] xl:mb-[3.6rem]">
              {title}
            </h1>
            <div className='flex flex-col lg:flex-row'>

              <div className='flex max-w-[42.6rem] xl:max-w-[48rem] flex-col mb-[4rem] lg:mb-0 gap-[1.6rem]'>
                {text.map((item, index)=> <p key={index} className="text-1  text-dark-blue">{item.text}</p>)}
              </div>
              <div className='w-full flex justify-end'>
               <h2 className='heading-3 text-right max-w-[32rem] xl:max-w-[40rem] [&>.selected]:italic [&>.selected]:text-dusty-green-dark' dangerouslySetInnerHTML={{__html: subtitle}}/>

              </div>
            </div>

        </div>
      </div>




    </section>
  );
};

export default PortfolioHero;